import { render, staticRenderFns } from "./smsForm.vue?vue&type=template&id=7e720248&"
import script from "./smsForm.vue?vue&type=script&lang=js&"
export * from "./smsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports